<template>
  <div class="team-report-result-team1-page">
    <div class="team-report-result-team1-page__intro">
      <i18n-t keypath="pdfReport.teampage1_heading" :locale="lang" tag="h2"></i18n-t>
      <i18n-t keypath="pdfReport.teampage1_desc" :locale="lang" tag="p"></i18n-t>
    </div>

    <i18n-t keypath="pdfReport.teampage1_leadership_spread" :locale="lang" tag="h3"></i18n-t>
    <spread-scale :multiColor="true" :data="reportData.individuals" :totalCount="reportData.totalCount" :isSpread="true" :lang="lang" />
    <br/>
    <i18n-t keypath="pdfReport.teampage1_leadership_characteristic" :locale="lang" tag="h3"></i18n-t>
    <spread-scale :multiColor="true" :data="reportData.individuals" :totalCount="reportData.totalCount" :isSpread="false" :lang="lang" />

  </div>
</template>

<script>
import SpreadScale from '../SpreadScale/SpreadScale.vue'
export default {
  components: {
    SpreadScale
  },
  props: {
    lang: '',
    reportData: {}
  }
}
</script>

<style scoped>
* {
  letter-spacing: initial!important;
}
h2 {
  font-size: 20px!important;
  margin: 0 0 4px 0!important;
  padding: 0!important;
  color: #000000;
}
h3 {
  font-size: 14px!important;
  margin: 16px 0 8px 0!important;
  padding: 0!important;
  color: #000000;
}
p,
p strong {
  font-size: 10px!important;
  margin: 0!important;
  padding: 0!important;
  max-width: 460px;
  color: #000000;
}
.team-report-result-team1-page {
  padding: 0 60px;
}
.team-report-result-team1-page__intro {
  width: 460px;
}
</style>
